var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('Search',{attrs:{"location":_vm.location,"title":_vm.title}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }